const palette = {
  light: {
    mode: "light",
    primary: {
      main: "#FF8C00",
    },
    secondary: {
      main: "#046a38",
    },
    background: {
      default: "#f7f5f2",
      paper: "#ffffff",
    },
    text: {
      primary: "#1f1f1f",
      secondary: "#5f6368",
      error: "#910000",
    },
    divider: "#e5e2dc",
  },
  dark: {
    mode: "dark",
    primary: {
      main: "#FF8C00",
    },
    secondary: {
      main: "#046a38",
    },
    background: {
      default: "#121212",
      paper: "#1a1a1a",
    },
    text: {
      primary: "#f5f5f5",
      secondary: "#b0b0b0",
      error: "#910000",
    },
    divider: "#2a2a2a",
  },
};

export default palette;
